import { ContextMenuItemType } from 'data/types';

export function hideSpaceContextMenu(): ContextMenuItemType[] {
  return [];
}
